import * as angular from 'angular';
import * as template from './template.html';
import './styling.scss';

import { CurrentUserService } from 'services/currentUser';
import { getScheduledPersonalPropertyDetails } from 'common/source/utilities/policyInfoHelper';
import { uppercaseFirstLetter } from 'common/source/utilities/strings';
import { ModalService } from 'common/source/services/modal';

const module = angular.module('coverage-scheduled-personal-property-section', []);

interface CoverageScheduledPersonalPropertySectionController extends angular.IStrictController {
    scheduledPersonalPropertyItems: Array<ScheduledPersonalPropertyDetail>;
    triggerEmail: () => void;
}

module.component('coverageScheduledPersonalPropertySection', {
    template: template,
    controller: function(
        this: CoverageScheduledPersonalPropertySectionController,
        currentUserService: CurrentUserService,
        $stateParams: PolicyStateParams,
        modalService: ModalService
    ) {
        'ngInject';

        this.$onInit = () => {
            const policyId = $stateParams.policyIndex;
            currentUserService.getCustomerPolicyInfoByIndex(policyId).then((policyInfo) => {
                this.scheduledPersonalPropertyItems = getScheduledPersonalPropertyDetails(policyInfo) || [];

                if (this.scheduledPersonalPropertyItems.length > 0) {
                    this.scheduledPersonalPropertyItems.forEach((item) => {
                        item.category = uppercaseFirstLetter(item.category);
                    });
                }
            });
        };

        // TODO: Implement contact me click handler
        this.triggerEmail = () => {
            modalService.openCloseableModal('contact-me-confirmation');
        };
    }
});

export { module };
